var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDowninline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.53 4.47a.75.75 0 0 1 0 1.06L8 12.06 1.47 5.53a.75.75 0 0 1 1.06-1.06L8 9.94l5.47-5.47a.75.75 0 0 1 1.06 0Z",
  fill: "#252829"
})));
export default SvgChevronDowninline;